<div class="rate-block">
  <button [disableRipple]="false" mat-icon-button *ngFor="let ratingId of ratingArr;index as i" [id]="'star_'+i" (click)="onClick(i+1)" [matTooltip]="ratingId+1" matTooltipPosition="above">
     <span [ngClass]="{'rating-color': rating >= i + 1}">
      <svg xmlns="http://www.w3.org/2000/svg" width="40" height="38" viewBox="0 0 40 38">
        <path id="star-filled" d="M41.939,16.8a2,2,0,0,0-1.718-1.331L28.857,13.824,23.764,3.556a2,2,0,0,0-3.6,0L15.076,13.8,3.711,15.472a1.953,1.953,0,0,0-1.118,3.337l8.249,7.944-2,11.281a1.98,1.98,0,0,0,.77,2.017,2.007,2.007,0,0,0,2.166.128l10.186-5.3,10.186,5.3a1.865,1.865,0,0,0,.919.238,2,2,0,0,0,1.178-.377,1.981,1.981,0,0,0,.8-1.986l-2-11.281L41.3,18.829A1.979,1.979,0,0,0,41.939,16.8Z" transform="translate(-2.006 -2.436)" fill="#D6DBDF"/>
      </svg>
     </span>
   </button>
</div>
